import apiClient from "../../client/apiClient"

export type BookClassification = {
  code: string
  title: string
}

export type BookClassificationsResponse = {
  success: boolean
  data: BookClassification[]
}

export type BookSubClassificationsResponse = {
  success: boolean
  data: {
    code: string
    title: string
    divisions: BookClassification[]
  }
}

const BOOK_CLASSIFICATIONS_ENDPOINT = {
  ROOT: "/library/book-classifications",
}

export const getBookClassifications =
  async (): Promise<BookClassificationsResponse> => {
    const response = await apiClient({
      url: BOOK_CLASSIFICATIONS_ENDPOINT.ROOT,
      method: "GET",
    })
    return response.data
  }

export const getBookSubClassifications = async (
  code: string,
): Promise<BookSubClassificationsResponse> => {
  const response = await apiClient({
    url: `${BOOK_CLASSIFICATIONS_ENDPOINT.ROOT}/${encodeURIComponent(code)}`,
    method: "GET",
  })
  return response.data
}
